import React, { useState, useEffect, useRef } from 'react';
import useWebSocket from 'react-use-websocket';
import { getFromLocalStorage } from './utils';
import parameters from '../configs/parameters';
import { getWebSocketToken } from './api';

const OrderWebSocket = ({
    updateOrderData,
    onConnectionChange
}) => {
    const [socketUrl, setSocketUrl] = useState(null);
    const messageQueue = useRef([]);
    const isProcessing = useRef(false);
    const hasConnectedOnce = useRef(false);
    const retryCountRef = useRef(0);

    const markDisconnectedAfterRetry = () => {
        if (retryCountRef.current === 0) {
            retryCountRef.current = 1;
            setSocketUrl(null);
            return;
        }

        if (onConnectionChange) {
            onConnectionChange(false);
        }
    };

    const { sendJsonMessage, lastMessage } = useWebSocket(socketUrl, {
        onOpen: () => {
            hasConnectedOnce.current = true;
            retryCountRef.current = 0;

            if (onConnectionChange) {
                onConnectionChange(true);
            }
            const hub = getFromLocalStorage('hub');
            const hubCode = hub?.value;

            if (hubCode) {
                sendJsonMessage({"action":"init", hubCode}, []);
            } else {
                const startTime = Date.now();
                const interval = setInterval(() => {
                    const hub = getFromLocalStorage('hub');
                    const hubCode = hub?.value;
                    if (hubCode) {
                        sendJsonMessage({"action":"init", hubCode}, []);
                        clearInterval(interval);
                    } else if (Date.now() - startTime > 10000) {
                        clearInterval(interval);
                    }
                }, 1000);
            }
        },
        onClose: () => {
            console.log('Socket closed');
            markDisconnectedAfterRetry();
        },        
        onError: () => {
            console.log('Socket Error');
            markDisconnectedAfterRetry();
        },
            heartbeat: {
                message: '{"action": "ping"}',
                returnMessage: '{"type":"pong"}',
                timeout: 180000
            },
        retryOnError: false,
    });

    const functionWrapper = (data) => {
        return new Promise((resolve) => {
            let dataObject = JSON.parse(data);

            if (dataObject && dataObject.code === 'PAYLOAD_TOO_LARGE') {
                onConnectionChange(false);
                resolve();
            } else {
                updateOrderData(data);
                resolve();
            }
        });
    };
    
    const processQueue = async () => {
        if (isProcessing.current) return;
        isProcessing.current = true;
        
        while (messageQueue.current.length > 0) {
            const message = messageQueue.current.shift();
            await functionWrapper(message.data);
        }
        isProcessing.current = false;
    };

    useEffect(() => {
        if (lastMessage !== null) {
            messageQueue.current.push(lastMessage);
        }
    }, [lastMessage]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (messageQueue.current.length > 0) {
                processQueue();
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!socketUrl) {
            getWebSocketToken().then(res => {
                const newUrl = parameters['websocketUrl'] + '?token=' + res.token;
                setSocketUrl(newUrl);
            });
        }
    }, [socketUrl]);

    return null;
}
export default OrderWebSocket;